import React from 'react';
import { Reveal } from './Reveal';

const CARDS = [
  {
    topBar: 'bg-evidence-grounded',
    pillClasses: 'bg-evidence-grounded-bg border-evidence-grounded text-evidence-grounded',
    pillBorder: 'border-solid',
    mark: '●',
    pillLabel: 'CITED',
    title: 'Grounded',
    body: 'Traces to a verified evidence item in your profile. The claim stands on something real.',
  },
  {
    topBar: 'bg-evidence-inferred-border',
    pillClasses: 'bg-evidence-inferred-bg border-evidence-inferred-border text-evidence-inferred',
    pillBorder: 'border-solid',
    mark: '◐',
    pillLabel: 'INFERRED',
    title: 'Inferred',
    body: 'A legitimate capability inference with a transparent chain — React implies JavaScript framework experience.',
  },
  {
    topBar: 'bg-evidence-gap-border',
    pillClasses: 'bg-evidence-gap-bg border-evidence-gap-border text-evidence-gap',
    pillBorder: 'border-dashed',
    mark: '○',
    pillLabel: 'NO EVIDENCE',
    title: 'Gap',
    body: 'No supporting evidence. The system is honest about what it doesn’t know — and flags it instead of bluffing.',
  },
];

/** Section 02 — the signature Evidence Chip and its three honest states. */
export function EvidenceChipSection() {
  return (
    <section id="evidence" className="max-w-[1180px] mx-auto px-5 sm:px-8 py-24 scroll-mt-20">
      <Reveal className="text-center max-w-[720px] mx-auto mb-[52px]">
        <div className="font-mono text-[11px] font-semibold tracking-[0.14em] text-bw-accent mb-4">
          02 — THE EVIDENCE CHIP
        </div>
        <h2 className="text-[clamp(32px,4vw,52px)] leading-[1.05] font-extrabold tracking-[-0.03em] text-bw-sidebar mb-[18px]">
          Every claim carries its evidence.
        </h2>
        <p className="text-lg leading-[1.6] text-fit-weak">
          One repeatable primitive runs through the whole product — a tappable chip that traces any
          AI assertion back to your profile. Three honest states.
        </p>
      </Reveal>

      <Reveal>
        <div className="flex flex-wrap gap-6">
          {CARDS.map((c) => (
            <div
              key={c.title}
              className="flex-1 basis-[300px] min-w-[260px] bg-bw-surface border border-bw-border rounded-[14px] overflow-hidden shadow-card"
            >
              <div className={`h-[5px] ${c.topBar}`} />
              <div className="p-7">
                <div
                  className={`inline-flex items-center gap-2 pl-[13px] pr-[13px] py-[7px] border-l-[3px] ${c.pillBorder} ${c.pillClasses} rounded-r-lg mb-[18px]`}
                >
                  <span>{c.mark}</span>
                  <span className="text-[13px] font-bold font-mono tracking-wide">{c.pillLabel}</span>
                </div>
                <h3 className="text-[19px] font-bold mb-2 text-bw-ink tracking-tight">{c.title}</h3>
                <p className="text-[15px] leading-[1.55] text-bw-muted">{c.body}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
